var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { attrs: { title: _vm.title } },
    [
      _c("p", { staticClass: "mb-4 text-gray-700" }, [
        _vm._v("This is where an AI Output Would Exist")
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass:
            "inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
          attrs: { to: "/" + _vm.id + "/backups" }
        },
        [
          _vm._v("\n    View Detailed Backup Reports\n    "),
          _c(
            "svg",
            {
              staticClass: "ml-2 h-4 w-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }
            },
            [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22cae3e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22cae3e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/BackupCard.vue
// module id = null
// module chunks = 